import type { Notification, NotificationKind, ProjectSummary } from "../types";
import { buildDetail } from "./detail";

/** Notifications for the sample portfolio: each open attention item, plus finished jobs (FR-PROJ-080). */

const KIND_OF: Readonly<Record<string, NotificationKind>> = {
  mention: "mention",
  approval: "approval",
  task: "assignment",
  stalled: "assignment",
  check: "failure",
};

const MS_PER_HOUR = 3_600_000;
/** Projects whose renders and plots finished recently, for "job" notifications. */
const JOB_PROJECTS = 3;

export function notifications(
  projects: readonly ProjectSummary[],
  now: number,
  extras: ReadonlyMap<string, { address?: string; plotAreaM2?: number }>,
): Notification[] {
  const live = projects.filter((p) => !p.archived);
  const fromAttention = live.flatMap((project) =>
    buildDetail(project, now, extras.get(project.id) ?? {}).attentionItems.map((item, index) => ({
      id: `${project.id}-n${String(index)}`,
      projectId: project.id,
      projectName: project.name,
      kind: KIND_OF[item.kind] ?? "comment",
      title: item.title,
      module: item.module,
      ...(item.tab === undefined ? {} : { tab: item.tab }),
      at: item.at,
      read: index > 0,
    })),
  );
  const jobs = live
    .filter((p) => p.modules.some((m) => m.module === "render"))
    .slice(0, JOB_PROJECTS)
    .map((project, index) => ({
      id: `${project.id}-job`,
      projectId: project.id,
      projectName: project.name,
      kind: "job" as const,
      title: "Render finished: Street view, golden hour",
      module: "render" as const,
      tab: "gallery",
      at: new Date(now - (index + 1) * 2 * MS_PER_HOUR).toISOString(),
      read: index > 0,
    }));
  return [...fromAttention, ...jobs].sort((a, b) => b.at.localeCompare(a.at));
}
